import { SleepDurationInputModal } from "./components/SleepDurationInputModal";
import { SleepTrackerChart } from "./components/SleepTrackerChart";
import { SleepTrackerProgressCard } from "./components/Progress/SleepTrackerProgressCard";
import { TrackerType } from "core/state/Trackers/TrackerType";
import { useTranslation } from "react-i18next";
import { Tracker } from "../components/Trackers/Tracker";
import PageTitle from "UIPalette/PageTitle/PageTitle";

export const SleepTracker = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle title={t("pageTitle.wellbeing.sleepTracker")} />
      <Tracker trackerType={TrackerType.Sleep} heading={t("wellbeing.trackers.sleep.title")}>
        <SleepTrackerProgressCard />
        <SleepTrackerChart />
        <SleepDurationInputModal />
      </Tracker>
    </>
  );
};
